<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header>Search</v-expansion-panel-header>
      <v-expansion-panel-content eager>
        <form @submit.prevent="onSubmit">
          <v-container fluid>
            <v-row v-if="error">
              <v-col cols="12">
                <v-alert border="top" colored-border type="error" elevation="2">
                  {{ error }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-select
                  small
                  :items="collections"
                  item-text="name"
                  return-object
                  label="Collection"
                  v-model="collection"
                  @change="onCollectionSelect"
                />
              </v-col>
              <v-col cols="6" class="keys-elements">
                <v-text-field
                  v-for="selector in selectors"
                  :key="selector"
                  :label="selector"
                  v-model="model[selector]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn type="submit" block elevation="2" color="primary">
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </form>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  methods: {
    onSubmit() {
      if (this.selector) {
        // check if all selector elements have been setted
        const errors = [];
        this.selectors.forEach(s => {
          if (!this.model[s]) {
            errors.push(s);
          }
        });
        if (errors.length === 0) {
          this.error = null;
          this.$emit('search', {
            collection: this.collection,
            values: this.model
          });
        } else {
          if (errors.length === 1) {
            this.error = `Value for ${errors.join(', ')} is missing`;
          } else {
            this.error = `Values for ${errors.join(', ')} are missing`;
          }
        }
      } else {
        this.error = 'Please choose an entity';
      }
    },
    onCollectionSelect(select) {
      this.error = null;
      this.model = {};
      this.selectors = select.selector.split(',');
      this.selector = select.name;
    }
  },
  props: {
    collections: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      error: null,
      model: {},
      selectors: [],
      selector: null,
      panel: 0,
      collection: null,
      id: null
    };
  }
};
</script>
